import { render, staticRenderFns } from "./RuleList.vue?vue&type=template&id=1f1075c1&scoped=true"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"
import style0 from "./RuleList.vue?vue&type=style&index=0&id=1f1075c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1075c1",
  null
  
)

export default component.exports